var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLostOnline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "668px",
    height: "858px",
    viewBox: "0 0 668 858",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 24.48,
    y: 112.72,
    width: 500.4,
    height: 744.48
  }), /*#__PURE__*/React.createElement("g", {
    id: "lostOnline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.825973,428.120507 C610.461281,470.787707 547.504171,480.558107 495.412452,465.697307 C478.367867,460.716153 461.924486,453.870791 446.38038,445.285307 C437.35158,440.382107 428.538938,435.003707 419.90598,429.272507 C417.781836,427.868507 415.658045,426.442907 413.555702,424.988507 C412.122739,424.009307 410.694694,423.018122 409.271566,422.01495 C391.444178,409.47255 374.315702,395.71335 357.474766,382.03335 C315.433872,347.88375 272.241252,312.68295 220.588286,296.38935 C209.946838,293.03415 196.180351,291.46455 189.599486,300.47895 C183.89011,308.30535 187.374794,319.38615 192.205973,327.781386 C210.126866,358.878186 242.656243,378.512586 275.214773,393.610986 C307.772978,408.709386 342.261259,420.942186 370.56415,443.017386 C398.867393,465.092586 420.474773,500.178186 414.685951,535.594986 C409.696222,566.115786 384.777151,590.912586 355.80415,601.719786 C326.831537,612.519786 294.518016,611.014986 264.400358,604.002186 C234.282708,596.982186 205.691558,584.734986 176.62505,574.179786 C159.100358,567.807786 136.190088,563.401386 124.561807,577.981386 C114.741259,590.300586 120.385951,609.733386 132.34505,619.986186 C144.30415,630.238986 160.490088,633.673386 175.93385,636.754986 C223.885922,646.330986 271.837992,655.904586 319.790059,665.475786 C334.499436,668.406186 349.554744,671.473386 362.370607,679.278186 C375.186816,687.075786 385.525922,700.698186 385.158888,715.695786 C384.791508,730.477386 373.970088,743.538186 360.707364,750.082986 C347.452402,756.620586 332.145022,757.628586 317.377987,756.922986 C262.038888,754.273386 103.386787,666.354186 65.334744,655.114986 C40.883544,647.900586 14.1500592,637.302186 3.839436,613.988543 C-8.9982216,584.965343 12.126816,549.850979 40.9626792,536.595743 C69.7914792,523.333343 103.213879,526.270943 134.634744,530.734979 C166.055645,535.198943 198.51295,540.879779 229.098888,532.398179 C259.684121,523.916579 287.706816,496.268536 284.690088,464.674979 C282.061807,437.185343 257.301288,416.470979 231.24415,407.341379 C210.846845,400.191779 189.145951,398.247779 167.718917,395.029379 C161.771537,394.143779 155.845951,393.150179 149.978016,391.926179 C134.950068,388.777618 120.290967,384.072228 106.238016,377.886179 C91.4911943,371.408478 77.4815062,363.368114 64.449216,353.902979 C54.0547318,346.364687 44.3408208,337.930025 35.4189456,328.695779 C34.0580448,327.284608 32.7115608,325.842208 31.3794936,324.368579 C30.1124592,322.957379 28.8594936,321.517379 27.6357024,320.048579 C11.709216,301.018979 -0.0558216,277.582979 3.4724592,253.434215 C6.9930072,229.350215 25.7636592,209.298215 48.1124592,199.664615 C61.029216,194.099015 74.9612592,191.607815 89.06598,191.247815 C99.379387,191.041695 109.68991,191.784018 119.867422,193.465415 C166.962737,200.996615 210.119494,223.878251 250.878946,248.653415 C291.630665,273.428615 331.34598,300.623015 375.647422,318.284615 C419.949216,335.953415 470.378045,343.434215 515.320387,327.457415 C560.262737,311.487815 597.184178,267.913415 594.988322,220.271015 C624.79625,245.939015 650.12598,278.202215 661.34363,315.901415 C672.561281,353.600507 668.053901,397.131722 643.825973,428.120507 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#44FF46",
    fillRule: "nonzero",
    cx: 429.055718,
    cy: 373.643493,
    r: 5.2399512
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6584",
    fillRule: "nonzero",
    cx: 614.095718,
    cy: 304.523493,
    r: 8.1014184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6584",
    fillRule: "nonzero",
    cx: 82.7357184,
    cy: 559.403493,
    r: 2.9933856
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.654803,387.325286 C168.656651,389.921749 168.342387,392.508782 167.718938,395.029286 C161.771558,394.143686 155.845973,393.150086 149.978038,391.926086 C134.95009,388.777525 120.290989,384.072134 106.238038,377.886086 C110.908157,362.807583 125.897559,353.406283 141.505252,355.766613 C157.112945,358.126943 168.652144,371.540127 168.654803,387.325286 L168.654803,387.325286 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 562.255718,
    cy: 357.083493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 282.175718,
    cy: 694.043493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 326.095718,
    cy: 736.523493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 54.6557184,
    cy: 615.563493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 205.135718,
    cy: 558.683493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 190.015718,
    cy: 254.843493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 375.055718,
    cy: 494.603493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 398.095718,
    cy: 547.883493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.487219,309.081618 C115.843075,307.766999 120.009912,306.342484 123.98773,304.808073 C148.439254,295.363696 162.46309,282.552059 162.46309,269.65745 C162.46309,256.76284 148.439268,243.951196 123.98773,234.506819 C121.569682,233.572893 119.077102,232.679265 116.50999,231.825935 C125.489976,257.178508 123.674323,285.105222 111.487219,309.081618 L111.487219,309.081618 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.142833,264.615686 C122.165241,280.073132 118.512885,295.314508 111.486866,309.082886 C110.558038,310.897286 109.574014,312.680486 108.534794,314.432486 C98.2458639,331.807869 82.8520367,345.590159 64.4491944,353.902886 C54.0547205,346.36458 44.3408106,337.92992 35.418924,328.695686 C34.0580232,327.284486 32.7115392,325.842086 31.379472,324.368486 C30.1124376,322.957286 28.859472,321.517286 27.6356808,320.048486 C11.7091944,301.018886 -0.0558432,277.582886 3.4724376,253.434122 C6.9929856,229.350122 25.7636376,209.298086 48.1124376,199.664478 C61.0291944,194.098878 74.9612376,191.607722 89.0659584,191.247722 C100.094458,200.987203 108.78865,213.08473 114.503609,226.642922 C115.223609,228.349322 115.885958,230.077322 116.512409,231.826922 C120.249072,242.354469 122.153424,253.444661 122.142833,264.615686 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.78273,269.655686 C166.78273,284.653286 152.138038,298.563686 125.541281,308.838086 C120.22038,310.897286 114.525072,312.762086 108.534794,314.432486 C86.1139008,320.682086 59.4306576,324.145286 31.3794864,324.368486 C30.112452,322.957286 28.8594864,321.517286 27.6356952,320.048486 C27.9380376,320.055686 28.24038,320.055686 28.5427296,320.055686 C59.0059728,320.055686 87.9068664,316.196486 111.486866,309.082886 C115.84273,307.765286 120.018938,306.339686 123.985973,304.806086 C148.437173,295.366886 162.46273,282.550886 162.46273,269.655686 C162.46273,256.760486 148.43713,243.951686 123.985973,234.505286 C121.566864,233.569286 119.07569,232.676486 116.512452,231.826886 C115.885973,230.077286 115.223652,228.349286 114.503652,226.642886 C118.333932,227.838086 122.013151,229.114886 125.54131,230.473286 C152.138038,240.747671 166.78273,254.665286 166.78273,269.655686 Z",
    id: "Path",
    fill: "#E4E4E4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 33.0557184,
    cy: 213.083493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 97.1357184,
    cy: 232.523493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 64.0157184,
    cy: 263.483493,
    r: 29.7708696
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.809209,421.0501 C607.127414,423.0229 592.396243,424.4773 576.196243,425.3701 C560.003623,426.2557 542.241281,426.6445 524.701843,427.0189 C494.001298,427.681338 463.302977,428.346138 432.606881,429.0133 C428.387431,429.1069 424.1538,429.1933 419.905987,429.2725 C417.781843,427.8685 415.658052,426.4429 413.55571,424.9885 C417.32131,425.0101 421.08691,424.9885 424.823638,424.9165 C440.785987,424.5997 454.300394,423.3541 469.693915,422.7637 C493.381843,421.8493 518.956258,422.5693 543.645115,422.9365 C568.333901,423.310914 596.464171,423.174114 613.809209,421.0501 Z",
    id: "Path",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.620185,648.016218 L44.757144,566.4901 L139.829486,651.281706 C140.335101,652.133442 141.334846,652.558689 142.299102,652.332173 C143.263358,652.105656 143.969189,651.279746 144.042679,650.291972 C144.116169,649.304197 143.540326,648.382931 142.620206,648.016218 L142.620185,648.016218 Z",
    id: "Path",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    cx: 68.3357184,
    cy: 336.203493,
    r: 3.0614184
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB6B6",
    fillRule: "nonzero",
    points: "325.45224 690.93328 338.11488 690.93256 344.13912 642.08992 325.45008 642.09064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.222183,686.798723 L325.786406,686.798579 L339.701681,681.139552 L347.159851,686.797715 L347.160859,686.797715 C355.937604,686.79818 363.052484,693.912948 363.053088,702.689692 L363.053088,703.206126 L322.222939,703.207638 L322.222183,686.798723 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB6B6",
    fillRule: "nonzero",
    points: "230.62176 690.93328 217.95912 690.93256 211.93488 642.08992 230.62392 642.09064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.851342,703.207638 L193.021193,703.206126 L193.021193,702.689692 C193.021805,693.912948 200.136685,686.798184 208.913429,686.797715 L208.914437,686.797715 L216.3726,681.139552 L230.287882,686.798579 L233.852098,686.798723 L233.851342,703.207638 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.994245,316.615353 L263.172578,326.378603 L229.112899,335.398619 C229.112899,335.398619 241.317144,421.050107 235.557144,426.810107 C229.797144,432.570107 234.991944,432.724907 233.834544,440.207514 C232.677144,447.690122 228.064896,467.445561 228.064896,467.445561 L329.720069,467.445561 C329.720069,467.445561 330.539198,455.167883 325.528171,452.508988 C320.517144,449.850093 330.147562,437.440007 326.052331,435.365068 C321.957101,433.290129 327.717122,415.290107 327.717122,415.290107 L340.19995,356.358446 L306.997805,330.381054 L301.948279,318.214833 L275.994245,316.615353 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 291.99253,
    cy: 388.716426,
    r: 4.4362224
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.064896,467.445554 L223.872905,575.388674 C223.872905,575.388674 205.773163,655.114086 208.917144,657.2101 C212.061125,659.306114 213.393002,671.80391 213.393002,671.80391 L231.208877,673.899923 C231.208877,673.899923 231.208877,665.515955 235.400861,662.37196 C239.592845,659.227965 278.368524,511.461206 278.368524,511.461206 L316.197144,654.330086 C316.197144,654.330086 317.144196,662.372003 320.288184,662.372003 C323.432172,662.372003 324.480168,673.899923 324.480168,673.899923 L342.295992,673.899923 L342.295992,662.372003 C342.295992,662.372003 350.301125,659.834003 347.157151,651.450086 C344.013178,643.066168 329.720076,467.445554 329.720076,467.445554 L228.064896,467.445554 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB6B6",
    fillRule: "nonzero",
    cx: 287.5,
    cy: 262.5,
    r: 63.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "326.052 385.17808 330.24384 388.32232 332.33976 373.65016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.121987,335.315279 C231.121987,335.315279 225.882036,334.26729 222.738055,343.699211 C219.594074,353.131132 208.066162,388.762845 208.066162,395.050778 C208.066162,401.33871 279.857513,429.082859 279.857513,429.082859 L272.387664,402.877739 L239.505869,385.618886 L231.121987,335.315279 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB6B6",
    fillRule: "nonzero",
    cx: 283.187664,
    cy: 412.957739,
    r: 12.24
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "238.54752 372.63784 239.50584 385.61872 269.91216 401.57824 242.86752 383.43784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.644224,374.488406 L311.249765,374.488406 L311.249765,363.682451 C311.249774,362.023737 310.59086,360.432955 309.417976,359.260063 C308.245091,358.087171 306.654315,357.428243 304.9956,357.428243 L282.101724,357.428243 C280.443006,357.428243 278.852223,358.087156 277.67933,359.260044 C276.506437,360.432932 275.847509,362.023712 275.847509,363.68243 L275.847509,422.964767 C275.847509,424.623481 276.506416,426.214261 277.6793,427.387153 C278.852184,428.560045 280.44296,429.218975 282.101674,429.218975 L304.995557,429.218975 C306.654273,429.218975 308.245055,428.56006 309.417946,427.387172 C310.590838,426.214284 311.249763,424.623505 311.249765,422.964789 L311.249765,382.180288 L311.644224,382.180288 L311.644224,374.488406 Z",
    id: "Path",
    fill: "#F0F0F0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.199971,356.358438 C340.199971,356.358438 343.343952,358.45443 345.439922,367.886358 C347.535893,377.318286 361.159776,412.949992 355.919825,421.333924 C350.679874,429.717856 349.133011,438.666016 331.317144,426.090114 L306.664207,403.518078 L324.480074,386.750214 L331.815996,391.990166 L340.199971,356.358438 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#44FF46",
    fillRule: "nonzero",
    cx: 293.82835,
    cy: 378.610478,
    r: 5.2399512
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB6B6",
    fillRule: "nonzero",
    cx: 308.997137,
    cy: 390.090107,
    r: 12.24
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "237.97008 411.8152 273.10752 427.35784 236.99376 420.29968"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-1047",
    fill: "#2F2E41",
    transform: "translate(292.000000, 175.500000) rotate(10.000000) translate(-292.000000, -175.500000) ",
    points: "202.433168 249.477865 147 181.186662 225.706011 177.167849 360.496319 23 360.068386 132.680587 437 115.098613 393.576572 212.511231 428.56399 253.019568 393.89759 250.957059 318.356267 248.223519 334.337095 276.300015 281.002005 265.928873 299.188731 286.195116 252.072252 290.805526 247.634534 328 219.171749 307.984213 185.594271 325.569988 196.565944 293.244358 168.267272 274.792536"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F89E9E",
    cx: 262.8,
    cy: 299.56,
    rx: 2.16,
    ry: 2.52
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostOnline);
export default __webpack_public_path__ + "static/media/lostOnline.3cf28f10733dc57651b5ef4ec8af8089.svg";
export { ForwardRef as ReactComponent };